angular.module('nv.shared.services.shared-state').service('ToolService', toolService);

function toolService() {
  return {
    groupTools(data, $scope) {
      _.each(data, function(v: any) {
        let type = v.tags[0];

        let scopes = {
          'core-tools'(v) {
            return $scope.toolListCore.push(v);
          },
          attendance(v) {
            return $scope.toolListAttendance.push(v);
          },
          'course-progress'(v) {
            return $scope.toolListCourseProgress.push(v);
          },
          regents(v) {
            return $scope.toolListRegents.push(v);
          },
          programming(v) {
            return $scope.toolListProgramming.push(v);
          },
        };

        scopes[type](v);
      });
    },
  };
}
